import { apiSliceV2 } from '../../apiSlice';

export const energyTreeNodesApiSlice = apiSliceV2.injectEndpoints({
  tagTypes: ['EnergyTreeNode'],
  endpoints: (builder) => ({
    getEnergyTreeNodes: builder.query({
      query: () => ({
        url: `/EnergyTreeNodes`,
      }),
      providesTags: ['EnergyTreeNode'],
    }),
    postEnergyTreeNodes: builder.mutation({
      query: ({ energyTreeNode, accountId }) => ({
        url: `/EnergyTreeNodes`,
        method: 'POST',
        body: energyTreeNode,
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyTreeNode', 'EnergyGroup'],
    }),
    putEnergyTreeNodes: builder.mutation({
      query: ({ accountId, energyTreeNodeId, updatedEnergyTreeNode }) => ({
        url: `/EnergyTreeNodes/${energyTreeNodeId}`,
        method: 'PUT',
        body: updatedEnergyTreeNode,
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyTreeNode', 'EnergyGroup'],
    }),
    deleteEnergyTreeNodes: builder.mutation({
      query: ({ accountId, energyTreeNodeId }) => ({
        url: `/EnergyTreeNodes/${energyTreeNodeId}`,
        method: 'DELETE',
        headers: {
          'X-Account-Id': accountId,
        },
      }),
      invalidatesTags: ['EnergyTreeNode', 'EnergyGroup'],
    }),
  }),
});

export const {
  useGetEnergyTreeNodesQuery,
  useLazyGetEnergyTreeNodesQuery,
  usePostEnergyTreeNodesMutation,
  usePutEnergyTreeNodesMutation,
  useDeleteEnergyTreeNodesMutation,
} = energyTreeNodesApiSlice;
